export default __webpack_public_path__ + "static/media/maul.4f015a85.png";